import React from 'react';
import { Button } from 'ui'
import {Popover, OverlayTrigger} from 'ui';

const PopoverButton = (props) => {
  const tooltip = (
    <Popover id="popover-tooltip">
      <div style={{fontSize:".8em"}}>
        {props.children}
      </div>
    </Popover>
  );

  const buttonElement = (
    <Button
      variant="white"
      onClick={props.onClick}
      disabled={!!props.disabled}
    >
      {props.name}
    </Button>
  );

  if (props.disabled) {
    return (
      <OverlayTrigger delayHide={0} placement="bottom" overlay={tooltip}>
        <div style={{position: 'relative'}}>
          <div style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            zIndex: 2
          }}/>
          {buttonElement}
        </div>
      </OverlayTrigger>
    );
  }

  return (
    <OverlayTrigger delayHide={0} placement="bottom" overlay={tooltip}>
      {buttonElement}
    </OverlayTrigger>
  );
};

export default PopoverButton;